import { render, staticRenderFns } from "./SquareCard.vue?vue&type=template&id=789ab7fc&scoped=true"
import script from "./SquareCard.vue?vue&type=script&lang=js"
export * from "./SquareCard.vue?vue&type=script&lang=js"
import style0 from "./SquareCard.vue?vue&type=style&index=0&id=789ab7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ab7fc",
  null
  
)

export default component.exports